import React from 'react';

import { Card, H2, Link, Separator, Text } from '@betterment/samba-react';

import { CoordinatedAccountRow, ManagedSubAccount } from './CoordinatedAccountRow';

import urlBuilder from '../../../Shared/url-builder';

export const CoordinatedAccountsCardView: React.FC<{
  subAccounts: ManagedSubAccount[];
  householdId: string;
  colorMode: 'light' | 'dark';
}> = ({ subAccounts, householdId, colorMode }) => {
  if (subAccounts.length <= 1) return null;

  return (
    <Card>
      <Card.Header
        css={{
          padding: 'space.300',
          display: 'flex',
          gap: 'space.50',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <H2 variant="title200">Coordinated Accounts</H2>
        <Text variant="text50" color="text.weak">
          Balance
        </Text>
      </Card.Header>
      <Card.Content>
        {subAccounts.map(subAccount => (
          <CoordinatedAccountRow
            key={subAccount.id}
            subAccount={subAccount}
            householdId={householdId}
            colorMode={colorMode}
          />
        ))}
      </Card.Content>
      <Separator css={{ fullWidthWithInset: 'space.300' }} />
      <Card.Footer css={{ padding: 'space.300' }}>
        <Link href={urlBuilder.getAddAccountPage.absolute({ householdId })}>Add new account</Link>
      </Card.Footer>
    </Card>
  );
};
